import React from 'react';
import { Warning } from '@phosphor-icons/react';
import { format, isSameMonth, isToday, parseISO } from 'date-fns';

const estadoConfig = {
  agendado: { color: '#6C757D', bgColor: '#6C757D20' },
  en_espera_asignacion: { color: '#0891B2', bgColor: '#0891B220' },
  asignado: { color: '#008630', bgColor: '#00863020' },
  realizada: { color: '#065F46', bgColor: '#065F4620' },
  suspendida: { color: '#78716C', bgColor: '#78716C20' },
  aprobado: { color: '#C1121F', bgColor: '#C1121F20' },
  rechazado: { color: '#FF3B30', bgColor: '#FF3B3020' },
};

export const CalendarDayCell = ({ day, currentMonth, dayMovs, hasConflict, onSelect }) => {
  const key = format(day, 'yyyy-MM-dd');
  const inMonth = isSameMonth(day, currentMonth);
  const dayIsToday = isToday(day);

  return (
    <button
      key={key}
      data-testid={`calendar-day-${key}`}
      onClick={() => onSelect(day)}
      className={`min-h-[110px] p-2 text-left transition-colors flex flex-col ${
        inMonth ? 'bg-white hover:bg-[#F8F9FA]' : 'bg-[#F8F9FA] hover:bg-[#F1F3F5]'
      } ${hasConflict ? 'ring-1 ring-inset ring-[#FF3B30]' : ''}`}
    >
      <div className="flex items-center justify-between mb-1">
        <span
          className={`text-sm font-medium font-['IBM_Plex_Sans'] ${
            inMonth ? 'text-[#0A0A0A]' : 'text-[#ADB5BD]'
          } ${dayIsToday ? 'bg-[#C1121F] text-white px-2 py-0.5' : ''}`}
        >
          {format(day, 'd')}
        </span>
        {hasConflict && <Warning size={12} weight="bold" className="text-[#FF3B30]" />}
      </div>

      <div className="flex-1 space-y-1 overflow-hidden">
        {dayMovs.slice(0, 3).map((mov) => {
          const st = estadoConfig[mov.estado] || estadoConfig.agendado;
          return (
            <div
              key={mov.id}
              className="text-xs font-['IBM_Plex_Sans'] truncate px-1.5 py-0.5"
              style={{ backgroundColor: st.bgColor, color: st.color }}
              title={`${format(parseISO(mov.fecha_inicio), 'HH:mm')} · ${mov.area} · ${mov.responsable}`}
            >
              <span className="font-bold">{format(parseISO(mov.fecha_inicio), 'HH:mm')}</span> {mov.area}
            </div>
          );
        })}
        {dayMovs.length > 3 && (
          <div className="text-xs text-[#6C757D] font-['IBM_Plex_Sans'] px-1.5">
            +{dayMovs.length - 3} más
          </div>
        )}
      </div>
    </button>
  );
};
